module.exports = __webpack_public_path__ + "media/images/eduardo-vazquez@2x-3b220ac5320e06ae675b0c158d84f771.png";